import dayjs, { Dayjs } from "dayjs";
import utcPlugin from "dayjs/plugin/utc";

dayjs.extend(utcPlugin);

export const getDateFromUtc = (utcTimestamp: number | undefined) => {
  return utcTimestamp
    ? (dayjs.utc(utcTimestamp) as Dayjs)
        .local()
        .format("MMMM DD, YYYY HH:mm:ss")
    : undefined;
};
